module.exports = __webpack_public_path__ + "media/images/cruze-logo-alt-76005a1db9eecc730c3a9aa7eeff42ff.jpeg";